import React from 'react';
import { Tooltip as MuiTooltip } from '@material-ui/core';
import classes from './Tooltip.module.scss';

const Tooltip = ({ children, ...props }) => {
  return (
    <MuiTooltip classes={{ popper: classes.tooltip }} placement='bottom-end' {...props}>
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
